import * as moment from 'moment';

Date.prototype["monthName"] = function () {
  var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return monthNames[this.getMonth()];
}
Date.prototype["shortDate"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("DD MMM YYYY");
  }
  else {
    return this.getDate() + " " + this["monthName"]() + " " + this.getFullYear();
  }
}
Date.prototype["shortDateNum"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("DDMMYYYY");
  }
  else {
    return this.getDate() + " " + this["monthName"]() + " " + this.getFullYear();
  }
}
Date.prototype["shortDateTime"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("DD MMM YYYY HH:mm:ss");
  }
  else {
    return this.getDate() + " " + this["monthName"]() + " " + this.getFullYear() + " " + pad(this.getHours(), 2) + ":" + pad(this.getMinutes(), 2) + ":" + pad(this.getSeconds(), 2);
  }
}
Date.prototype["shortDateTimeExclSec"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("DD MMM YYYY HH:mm");
  }
  else {
    return this.getDate() + " " + this["monthName"]() + " " + this.getFullYear() + " " + pad(this.getHours(), 2) + ":" + pad(this.getMinutes(), 2);
  }
}
Date.prototype["time"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("HH:mm:ss");
  }
  else {
    return pad(this.getHours(), 2) + ":" + pad(this.getMinutes(), 2) + ":" + pad(this.getSeconds(), 2);
  }
}
Date.prototype["shortTime"] = function () {
  if (this == null) return null;
  if (moment) {
    return moment(this).format("HH:mm");
  }
  else {
    return pad(this.getHours(), 2) + ":" + pad(this.getMinutes(), 2);
  }
}
String.prototype["lpad"] = function (padChar, length) {
  var str = this;
  while (str.length < length)
    str = padChar + str;
  return str;
}
function pad(value, width, padChar?) {
  padChar = padChar || '0';
  value = value + '';
  return value.length >= width ? value : new Array(width - value.length + 1).join(padChar) + value;
}
Math["guid"] = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
String.prototype["formatNumberWithThousandSeperator"] = function () {
  return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
String.prototype["splitWord"] = function () {
  let str: String = this,
    newStr: string = "",
    prevChrIsUpper: boolean = true,
    length: number = 0;
  while (length < str.length) {
    let ch: string = str[length++];
    if (!prevChrIsUpper && ch == ch.toUpperCase()) newStr += " ";
    prevChrIsUpper = (ch == ch.toUpperCase());
    newStr += ch;
  }
  return newStr;
}
String.prototype["repeat"] = function (count: number): string {
  let str: String = this,
    newStr: string = "";
  while (count--) newStr += str;
  return newStr;
}
Number.prototype["roundNumber"] = function (decimals) {
  let number: Number = this;
  var newnumber = new Number(number + '').toFixed(parseInt(decimals));
  return parseFloat(newnumber);
}
